import { inject } from 'mobx-react';
import * as React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { History, Location, LocationState } from 'history';
import routes, { navigationSections } from 'src/Routes';
import { Router } from 'src/routing';
import { IStores } from 'src/Stores';
import NavigationDrawer from '../NavigationDrawer';

const styles = createStyles({
    drawerContainer: {
        height: '100%',
    },
});
interface IShellProps extends WithStyles<typeof styles> {
    history?: History;
    isDrawerOpen?: boolean;
    isLoggedIn?: boolean;
    location?: Location<LocationState>;
    rerouteIfNotLoggedIn?: (location?: Location<LocationState>) => void;
    toggleDrawer?: () => void;
}

class Shell extends React.Component<IShellProps> {
    public componentWillMount() {
        this.props.rerouteIfNotLoggedIn!();
        this.props.history!.listen((location) => {
            this.props.rerouteIfNotLoggedIn!(location);
        });
    }

    public render() {
        const { classes, history, isDrawerOpen, isLoggedIn, location, toggleDrawer } = this.props;
        const isOnLogin = !location || location.pathname === '/login';
        const container: React.SFC = (props) => (
            <div
                className={classes.drawerContainer}
                style={{
                    marginLeft: `${this.props.isLoggedIn ? (isDrawerOpen ? 224 : 72) : 0}px`,
                }}
            >
                {props.children}
            </div>
        );

        return (
            <Router container={container} routes={routes} history={history!}>
                {isLoggedIn && !isOnLogin && (
                    <NavigationDrawer
                        isOpen={isDrawerOpen!}
                        toggleDrawer={toggleDrawer!}
                        navigationSections={navigationSections}
                    />
                )}
            </Router>
        );
    }
}

const InjectedShell = inject<IStores, IShellProps, Partial<IShellProps>, any>(
    (stores: IStores) => ({
        history: stores.routing.history,
        isDrawerOpen: stores.global.isDrawerOpen,
        isLoggedIn: stores.global.isLoggedIn,
        location: stores.routing.location,
        rerouteIfNotLoggedIn: stores.global.rerouteIfNotLoggedIn,
        toggleDrawer: stores.global.toggleDrawer,
    })
)(withStyles(styles)(Shell));

export default InjectedShell;



// WEBPACK FOOTER //
// ./src/core/Shell/Shell.tsx